import React from "react";

interface Props {
  label: string;
}
const LabelController = (props: Props) => {
  return (
    <label htmlFor="" className="main-label">
      {props.label}
    </label>
  );
};

export default LabelController;
